export const sortOptions = [
    { label: "Name: A-Z", value: "name-asc" },
    { label: "Name: Z-A", value: "name-desc" },
    { label: "Date: Newest First", value: "date-desc" },
    { label: "Date: Oldest First", value: "date-asc" },
];
